import { ThemeUICSSObject } from 'theme-ui';

export enum BADGE_VARIANTS {
  'primary' = 'primary',
  'pink' = 'pink',
  'green' = 'green',
  'yellow' = 'yellow',
  'red' = 'red',
  'grey' = 'grey',
}

export const defaultBadgeStyles = (outlineColor: string): ThemeUICSSObject => ({
  transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out',
  fontFamily: 'body',
  fontWeight: 'medium',
  fontSize: 'body',
  paddingX: 2,
  paddingY: 1,
  borderRadius: 'lg',
  ':focus': {
    outlineStyle: 'solid',
    outlineColor: outlineColor,
  },
  boxShadow: 'xs',
});

export const badges: Record<BADGE_VARIANTS, ThemeUICSSObject> = {
  primary: {
    ...defaultBadgeStyles('blueScale.4'),
    color: 'blueScale.4',
    backgroundColor: 'blueScale.1',
  },
  pink: {
    ...defaultBadgeStyles('pinkScale.4'),
    color: 'pinkScale.4',
    backgroundColor: 'pinkScale.1',
  },
  green: {
    ...defaultBadgeStyles('greenScale.4'),
    color: 'greenScale.4',
    backgroundColor: 'greenScale.1',
  },
  grey: {
    ...defaultBadgeStyles('blueScale.4'),
    color: 'blueScale.4',
    backgroundColor: 'muted',
  },
  yellow: {
    ...defaultBadgeStyles('yellowScale.4'),
    color: 'yellowScale.4',
    backgroundColor: 'yellowScale.1',
  },
  red: {
    ...defaultBadgeStyles('redScale.4'),
    color: 'redScale.4',
    backgroundColor: 'redScale.1',
  },
};
